import React, {Component} from "react";
import PanelGroupController from "../PanelGroupController";
import ActionButton from "../ActionButton";
import WarehousePropertiesPanel from "./WarehousePropertiesPanel";

const CONTEXT = "warehouses";

class WarehousePanelSet extends Component {

  render() {
    if (this.props.context !== CONTEXT) return null;

    return (
      <div className="content">
        <WarehousePropertiesPanel 
          expanded={true} 
          selected={this.props.selectedWarehouse}
          hasSelection={this.props.hasSelection}
          />      
        <PanelGroupController title="Actions">
          <ActionButton label="Register Warehouse" onClick={this.handleRegisterWarehouse.bind(this)} />
          <ActionButton label="Assign Warehouse Backup" active={this.props.hasSelection} onClick={this.handleAssignWarehouseBackup.bind(this)} />
          <ActionButton label="Set Operation Hours" active={this.props.hasSelection} onClick={this.handleSetOperationHours.bind(this)} />
          <ActionButton label="Rename Warehouse" active={this.props.hasSelection} onClick={this.handleRenameWarehouse.bind(this)} />
          <ActionButton label="Change Address" active={this.props.hasSelection} onClick={this.handleChangeAddress.bind(this)} />
          <ActionButton label="Change Contact" active={this.props.hasSelection} onClick={this.handleUpdateContact.bind(this)} />
          <ActionButton label="Assign Courier" active={this.props.hasSelection} onClick={this.handleAssignCourier.bind(this)} />
        </PanelGroupController>
      </div>
    );
  }

  handleChangeAddress() {
    this.props.requestChangeWarehouseAddress(this.props.selection);
  }

  handleUpdateContact() {
    this.props.requestChangeWarehouseContact(this.props.selection);
  }

  handleRegisterWarehouse() {
    // Popup window.
    this.props.requestRegisterWarehouse();
  }

  handleRenameWarehouse() {
    // Popup window.
    this.props.requestRenameWarehouse(this.props.selection);
  }

  handleAssignCourier() {
    this.props.requestAssignWarehouseCourier(this.props.selection);
  }

  handleSetOperationHours() {
    this.props.requestSetOperationHours(this.props.selection);
  }

  handleAssignWarehouseBackup() {
    this.props.requestAssignWarehouseBackup(this.props.selection);
  }

}

export default WarehousePanelSet;